import { useMutation } from '@tanstack/react-query';
import uuid from 'react-native-uuid';
import { ApiLogger, getAdditionalProperties } from 'fmc-digital-common';
import { Platform } from 'react-native';
const useUploadFilesMutation = () => {
  const correlationId = uuid.v4().toString();
  const selfServUrl = getAdditionalProperties('selfServUrl');
  const authToken = getAdditionalProperties('authToken');
  const xApiKey = getAdditionalProperties('xAPIKey');
  //@ts-ignore
  const loanNumber = getAdditionalProperties('amplify')?.loanNumber;
  return useMutation({
    mutationFn: ({
      file,
      documentName
    }) => {
      const webRequestBody = new FormData();
      webRequestBody.append('documentName', documentName);
      //@ts-ignore
      webRequestBody.append('file', new Blob([file]), file.name);
      const config = {
        method: 'post',
        url: `${selfServUrl}/${loanNumber}/documents`,
        headers: {
          ...(Platform.OS !== 'web' ? {
            'Content-Type': 'application/json'
          } : {
            'Content-Type': 'multipart/form-data'
          }),
          'Authorization': `Bearer ${authToken}`,
          'x-correlation-id': correlationId,
          'x-api-key': `${xApiKey}`
        },
        data: Platform.OS !== 'web' ? {
          content: documentName,
          attachments: [{
            title: file.name,
            content: file.content
          }]
        } : webRequestBody
      };
      return ApiLogger(config);
    }
  });
};
export { useUploadFilesMutation };
//# sourceMappingURL=DocUpload.js.map